import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

interface Parameter {
    id: string;
    productidlist: string;
}

export interface CustomGetProductCollectionApiV2Parameter extends GetProductCollectionApiV2Parameter {
    productNumbers?: string[];
}

interface Props {
    getProductCollectionParameter?:
        | CustomGetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter;
    extraProductCollectionParameter?: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter;
}

type HandlerType = Handler<Parameter, Props>;

export const LoadProductswithId: HandlerType = props => {
    const {
        parameter: { productidlist },
    } = props;

    props.getProductCollectionParameter = {
        productNumbers: productidlist.split(","),
        expand: ["content"],
    };
};

export const LoadProducts: HandlerType = props => {
    if (!props.getProductCollectionParameter) {
        return;
    }
    props.dispatch(
        loadProductInfoList({
            id: props.parameter.id,
            getProductCollectionParameter: props.getProductCollectionParameter,
        }),
    );
};

export const chain = [LoadProductswithId, LoadProducts];

const intLoadProductsWithIds = createHandlerChainRunner(chain, "IntLoadProductsWithIds");
export default intLoadProductsWithIds;
